// Filename: bumble.js
// Timestamp: 2018.01.19-23:55:13 (last modified)
// Author(s): bumblehead <chris@bumblehead.com>

import gninitweb from '@bumblehead/gani'
import iswebglcontext from 'iswebglcontext'
import curved from 'curved'
import touchboom from 'touchboom'
import lockfnthrottling from 'lockfn/throttling'
import appCfg from './appCfg.js'
// import './bumble_sentry.js'

import {
  Mesh as THREEMesh,
  MeshBasicMaterial as THREEMeshBasicMaterial,
  MeshNormalMaterial as THREEMeshNormalMaterial,
  Object3D as TRHEEObject3D,
  Raycaster as THREERaycaster,
  Vector2 as THREEVector2,
  Vector3 as THREEVector3,
  Scene as THREEScene,
  GridHelper as THREEGridHelper,
  FrontSide as THREEFrontSide,
  SphereGeometry as THREESphereGeometry,
  WebGLRenderer as THREEWebGLRenderer,
  PerspectiveCamera as THREEPerspectiveCamera,
  BufferGeometry as THREEBufferGeometry,
  BufferAttribute as THREEBufferAttribute,
  LineSegments as THREELineSegments,
  EdgesGeometry as THREEEdgesGeometry,
  LineBasicMaterial as THREELineBasicMaterial
} from 'three'

const win = typeof window === 'object' ? window : {},
      location = win.location || {}

export default gninitweb(appCfg, {
  // <meta name="prefix" content="/path/">
  prefixweb: ((meta => meta
    && meta.getAttribute('content')
  )((win.document.querySelector("meta[name='prefix']")))),
  version: win.appversion,
  startts: win.startts,
  origin: win.location.origin,
  locallinkdynamicis: true,
  loglevels: String(location.href).includes('islogenabled=true')
    ? ['warnings', 'reports', 'patchjobs']
    : [],
  fpms: iswebglcontext && 20,

  initcfg: cfg => {
    cfg.curved = curved
    cfg.touchboom = touchboom
    cfg.lockfnthrottling = lockfnthrottling
    cfg.THREE = {
      Mesh: THREEMesh,
      MeshBasicMaterial: THREEMeshBasicMaterial,
      MeshNormalMaterial: THREEMeshNormalMaterial,
      LineBasicMaterial: THREELineBasicMaterial,
      Raycaster: THREERaycaster,
      Vector2: THREEVector2,
      Vector3: THREEVector3,
      Object3D: TRHEEObject3D,
      Scene: THREEScene,
      GridHelper: THREEGridHelper,
      FrontSide: THREEFrontSide,
      WebGLRenderer: THREEWebGLRenderer,
      PerspectiveCamera: THREEPerspectiveCamera,
      LineSegments: THREELineSegments,
      EdgesGeometry: THREEEdgesGeometry,
      BufferGeometry: THREEBufferGeometry,
      SphereGeometry: THREESphereGeometry,
      BufferAttribute: THREEBufferAttribute
    }

    return cfg
  }
})
